const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export const saveDesignApi = async ({ token, designJson, previewImage, size = '6x4' }) => {
  const response = await fetch(`${API_BASE_URL}/save-design`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({ designJson, previewImage, size })
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || 'Failed to save design.');
  }

  return data;
};

export const getDesignsApi = async ({ token }) => {
  const response = await fetch(`${API_BASE_URL}/designs`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`
    }
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || 'Failed to fetch designs.');
  }

  return data.designs || [];
};

export const exportPdfApi = async ({ token, designId, designJson, previewImage, size = '6x4' }) => {
  const response = await fetch(`${API_BASE_URL}/export-pdf`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({ designId, designJson, previewImage, size })
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || 'Failed to export PDF.');
  }

  return data;
};

export const createOrderApi = async ({ token, designId, address }) => {
  const response = await fetch(`${API_BASE_URL}/orders`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({ designId, address })
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || 'Failed to create order.');
  }

  return data;
};

export const getOrdersApi = async ({ token }) => {
  const response = await fetch(`${API_BASE_URL}/orders`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`
    }
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || 'Failed to fetch orders.');
  }

  return {
    orders: data.orders || [],
    allowedStatuses: data.allowedStatuses || [],
    supportedProviders: data.supportedProviders || []
  };
};

export const updateOrderStatusApi = async ({ token, orderId, status }) => {
  const response = await fetch(`${API_BASE_URL}/orders/${orderId}/status`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({ status })
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || 'Failed to update order status.');
  }

  return data;
};

export const submitOrderToProviderApi = async ({ token, orderId, provider }) => {
  const response = await fetch(`${API_BASE_URL}/orders/${orderId}/submit-print`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({ provider })
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || 'Failed to submit order to provider.');
  }

  return data;
};
